import CountryIllustration from "./Country/CountryIllustration";
import IndustryIllustration from "./Industry/IndustryIllustration";
import JobInterestIllustration from "./JobInterest/JobInterestIllustration";
import SuccessIllustration from "./Success/SuccessIllustration";
import VerificationIllustration from "./Verification/VerificationIllustration";

type IllustrationProps = {
  type: "industry" | "country" | "residency" | "yearsOfExperience" | "job" | "success" | "register" | "verification";
};

const Illustration = ({ type }: IllustrationProps) => {
  switch (type) {
    case "industry":
      return <IndustryIllustration />;
    case "job":
      return <JobInterestIllustration />;
    case "country":
      return <CountryIllustration />;
    case "success":
      return <SuccessIllustration />;
    case "register":
      return (
        <div className="w-full h-full flex items-center justify-center p-10">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            viewBox="0 0 24 24"
            className="text-primary-500"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
            <circle cx="9" cy="7" r="4"></circle>
            <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
            <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
          </svg>
        </div>
      );
    case "verification":
      return <VerificationIllustration />;
    default:
      return (
        <div className="w-full h-full bg-gradient-to-br from-red-50 to-rose-100 flex items-center justify-center">
          <div className="text-[#C71F2C] text-2xl font-medium">Canada Prime Jobs</div>
        </div>
      );
  }
};

export default Illustration;
